import React from 'react';
import { Box, Heading, Text, Icon, Image } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LegarooIcon } from '@src/icons/logo.svg';

const ComingSoon: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('coming_soon.seo.title')}</title>
        <meta name="description" content={t('coming_soon.seo.description')} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        w="full"
        height="100vh"
        position="relative"
        backgroundColor="white"
        backgroundPosition="center -50px"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundImage={{
          base: 'none',
          md: "url('/images/hero-bg-man.png')",
        }}
      >
        <Box
          maxW="5xl"
          mx="auto"
          py={{ base: 10, md: 20 }}
          px={6}
          d="flex"
          flexDir={{ base: 'column', md: 'row' }}
          justifyContent="center"
          alignItems="center"
        >
          <Box
            d="flex"
            flexDirection="column"
            justifyContent="flex-end"
            w={{ base: '100%', md: '50%', lg: '45%' }}
            textAlign="left"
            data-testid="coming-soon-hero"
          >
            <Icon as={LegarooIcon} w={48} h="auto" />
            <Heading
              as="h1"
              lineHeight="1.2"
              fontSize={{ base: '2.2rem', md: '6xl' }}
              fontWeight="bold"
              textAlign="left"
              color="black"
            >
              {t('coming_soon.title')}
            </Heading>
            <Text pt={2} color="black" textAlign="left" maxW="600px">
              {t('coming_soon.description')}
            </Text>
            <Box
              pt={1}
              justifyContent="center"
              d="flex"
              width="100%"
              flexDirection="column"
              alignItems="left"
            >
              <Box pt={2} as="span" textStyle="secondary" textAlign="left">
                {t('coming_soon.copyright')}
              </Box>
            </Box>
          </Box>
          <Box
            d="flex"
            mt={{ base: -7, md: 'auto' }}
            mx={{ base: -6, md: 'auto' }}
            minH={{ base: '555px', md: 'auto' }}
            bg="red"
            backgroundSize="cover"
            backgroundPosition="right"
            backgroundImage={{
              base: "url('/images/hero-bg-man.png')",
              md: 'none',
            }}
            className="clip-image-bottom-right-lawyers"
          >
            <Image
              src="/images/hero-atoms.png"
              w={{ base: '320px', md: '400px' }}
              m="auto"
              ml={{ base: '4', md: 'auto' }}
              pt={{ base: 16, md: 'auto' }}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ComingSoon;
